import {
  Box,
  Button,
  Container,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import GlobalFullDialog from "../../../mui/Dialogue/GlobalFullDialog";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { getPreInvoice } from "../../../../redux/features/ogdSlice";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import GlobalWrapper from "../../../Wrapper/GlobalWrapper";
import { DataGrid } from "@mui/x-data-grid";
import dayjs from "dayjs";
import payment from "../../../../../src/img/payment.png";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import NoDataFound from "../../../NodataIndication/NoDataFound";

const PreInvoice = (params) => {
  const { preInvoice, loading } = useSelector((state) => state.ogd);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  let componentRef = useRef(null);
  const handleClickOpen = () => {
    setOpen(true);
  };
  useEffect(() => {
    if (open) {
      dispatch(
        getPreInvoice(
          // 192904
          params.leadId
        )
      );
    }
  }, [open]);
  const downloadPdf = useReactToPrint({
    //BROWSER PREVIEW PAGE TO DOWNLOAD AND PRINT
    content: () => componentRef.current,
    documentTitle: `Pre Invoice`,
    onPrintError: () => alert("error occured"),
    // onAfterPrint: () => setconfirmedAlert(false),
  });
  const col = [
    {
      field: "courseName",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      flex: 3, // 30% of the width
      renderCell: (params) => (
        <Box sx={{ paddingLeft: 1 }}>{params.value.replace(/_/g, " - ")}</Box> // Apply padding left
      ),
      renderHeader: (params) => (
        <Box sx={{ paddingLeft: 2 }}>{params.colDef.headerName}</Box> // Apply padding left to the header
      ),
    },
    {
      field: "sessions",
      headerName: "Sessions/Hours",
      type: "number",
      headerClassName: "super-app-theme--header",
      flex: 1, // 20% of the width
      // renderCell: (params) => `₹ ${parseFloat(params.value).toFixed(2)}`
      renderCell: (params) => (params.value ? `${params.value}` : ""),
    },
    {
      field: "actualfee",
      headerName: "Actual Fee",
      type: "number",
      headerClassName: "super-app-theme--header",
      flex: 1, // 10% of the width
      renderCell: (params) => (params.value ? `₹ ${params.value}` : ""),
    },
    {
      field: "discount",
      headerName: "Discount",
      type: "number",
      headerClassName: "super-app-theme--header",
      flex: 1, // 10% of the width
      renderCell: (params) => `${params.value}`,
    },
    {
      field: "totalfee",
      headerName: "Total Fee",
      type: "number",
      headerClassName: "super-app-theme--header",
      flex: 1, // 10% of the width
      renderCell: (params) => `₹ ${params.value}`,
    },
  ];

  let modifiedRow = [
    ...(preInvoice?.totalAdmissionFees
      ? [
          {
            courseName: "Admission Fee",
            actualfee: null,
            discount: 0,
            totalfee: 500,
            sessions: null,
            admissionfee: null,
            id: 0,
          },
        ]
      : []),

    ...(Array.isArray(preInvoice?.courses)
      ? preInvoice.courses.map((data, index) => ({
          ...data,
          id: index + 1, // Ensuring subsequent items have correct ids
        }))
      : []),
  ];

  const [date, setDate] = useState(dayjs());

  return (
    <GlobalFullDialog
      open={open}
      setOpen={setOpen}
      title={"Pre Invoice"}
      popupButton={
        <Box>
          <Button
            size="small"
            onClick={handleClickOpen}
            sx={{
              color: "white",
              background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
              borderRadius: 3,
            }}
          >
            <Icon icon="material-symbols:print" height={22} width={22} />
            PreInvoice
          </Button>
        </Box>
      }
      content={
        <>
        {Object.keys(preInvoice).length > 0 ?(
          <Container sx={{ p: 1 }}>
          <GlobalWrapper
            actions={
              <>
                <Box>
                  <Button variant="contained" onClick={downloadPdf}>
                    <Icon icon="ion:print-outline" height="25" width="25" />
                    Download PreInvoice
                  </Button>
                </Box>
              </>
            }
          >
            <Box mb={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="Offer Validity"
                    value={date}
                    onChange={(newValue) => setDate(newValue)}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
            <Box className="print-content">
              <Box
                sx={{
                  p: 1,
                  width: "1000px",
                  //  height: "1450px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
                ref={componentRef}
              >
                <Box>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Box>
                      <img
                        height="45"
                        src="https://www.intervaledu.com/static/web/images/logo/logo-dark.png"
                        alt="header"
                      />
                    </Box>
                    <Box>
                      <Stack>
                        <Typography color="#008fc3" variant="h6">
                          INVOICE
                        </Typography>
                        {/* <Typography variant="subtitle2" fontWeight={"bolder"}>
                          Invoice No : {preInvoice?.invoiceId}
                        </Typography> */}
                        <Typography variant="subtitle2" fontWeight={"bolder"}>
                          Date :{" "}
                          {dayjs(preInvoice?.invoiceDate).format("DD-MM-YYYY")}
                        </Typography>
                      </Stack>
                    </Box>
                  </Box>

                  <Box mt={2}>
                    <Typography variant="h6">Student Details</Typography>
                    <Typography variant="subtitle2">
                      Name : {preInvoice.studentName}
                    </Typography>
                    <Typography variant="subtitle2">
                      Class : {preInvoice.class}
                    </Typography>
                    <Typography variant="subtitle2">
                      Place : {preInvoice.place ? preInvoice.place : ""}
                    </Typography>

                    {preInvoice?.ogaName && (
                      <Typography variant="subtitle2">
                        OGA : {preInvoice.ogaName}
                      </Typography>
                    )}
                  </Box>

                  <Box sx={{ my: 3 }}>
                    <Divider sx={{ borderBottomWidth: 2 }} />
                  </Box>

                  <Box
                    className="invoiceDatagrid"
                    sx={{
                      borderRadius: 1.2,

                      border: "1px solid #ddd", // Border around the whole table
                      "& .super-app-theme--header": {
                        backgroundColor: "#7e4d8b", // Header background color
                        color: "white", // White text for the header
                        fontWeight: "bold", // Make header text bold
                        textAlign: "center", // Center-align header text
                        padding: "8px 0", // Add padding inside headers
                      },
                      "& .MuiDataGrid-cell": {
                        padding: "8px", // Add padding inside cells for better readability
                        borderBottom: "1px solid #ddd", // Add a bottom border between rows
                      },
                      "& .MuiDataGrid-row:nth-of-type(odd)": {
                        backgroundColor: "white", // Odd rows
                      },
                      "& .MuiDataGrid-row:nth-of-type(even)": {
                        backgroundColor: "#f5f5f5", // Even rows (light gray)
                      },
                    }}
                  >
                    <DataGrid
                      rows={modifiedRow}
                      columns={col.map((column) => ({
                        ...column,
                        headerAlign:
                          column.headerName == "Description"
                            ? "left"
                            : "center", // Center-align all headers
                        align:
                          column.headerName == "Description"
                            ? "left"
                            : "center",
                        sortable: false, // Disables sorting on all columns
                        filterable: false, // Disables filtering on all columns
                        // align: column.type === "number" ? "right" : "left", // Right-align numeric columns
                      }))}
                      autoHeight={true}
                      disableColumnMenu
                      hideFooter
                      disableSelectionOnClick
                    />
                  </Box>

                  <Box sx={{ mt: 4, mb: 2 }}>
                    <Divider sx={{ borderBottomWidth: 2 }} />
                  </Box>

                  <Box
                    ml={1}
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        color: "red",
                      }}
                    >
                      <Typography>
                        Offer Valid Till :{" "}
                        {date ? date.format("DD-MM-YYYY") : ""}
                      </Typography>
                    </Box>
                    <Box sx={{ mr: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography color="#008fc3" variant="subtitle1">
                            TOTAL
                          </Typography>
                          <Typography ml={3} mr={2} variant="subtitle1">
                            {`₹ ${new Intl.NumberFormat("en-IN").format(
                              preInvoice?.totalAmount || 0
                            )}`}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  <Box></Box>
                </Box>

                <Box sx={{ mt: 5 }}>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Typography variant="caption">
                      SANCO INDIA EDU SOLUTIONS PRIVATE LIMITED
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Typography variant="caption">
                      GSTIN : 32ABFCS2058H1ZI
                    </Typography>
                  </Box>
                </Box>
                {/* <Box mt={2}>
                  <img
                    // height="45"
                    src={payment}
                    alt="header"
                  />
                </Box> */}
              </Box>
            </Box>
          </GlobalWrapper>
        </Container>

        ): <NoDataFound/>}
        </>
      }
    />
  );
};

export default PreInvoice;
